<!-- TODO do something smarter to load modules -->
<template>
  <div class="api-modules">
    <div v-if = "showModules" id = "content">
      <transition-group name = "slidevertical" mode = "out-in">
        <api-console v-show = "editorConfig.selectedModule === 'api-console'" key = 'apiconsole'></api-console>
        <api-storage v-show = "editorConfig.selectedModule === 'api-storage'" key = 'apistorage'></api-storage>
        <api-mlp-phone v-show = "editorConfig.selectedModule === 'api-mlp-phone'" key = 'apimlpphone'></api-mlp-phone>
        <api-mlp-tracking v-show = "editorConfig.selectedModule === 'api-tracking'" key = 'apitracking'></api-mlp-tracking>
        <api-events v-show = "editorConfig.selectedModule === 'api-events'" key = 'apievents'></api-events>
      </transition-group>
    </div>
    <div id = "toolbar">
      <!-- <span id = "title">Api Modules</span> -->
      <div id = "selector">
        <b-tooltip v-for = "m in modules" :key = "m.name" :label = "m.name">
          <button class = "btn btn-icon btn-squared"  v-on:click = "click_on_module(m.id)" :class = "{ selected: editorConfig.selectedModule === m.id }"><span class = "material-icons md-24">{{m.icon}}</span></button>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import ApiConsole from './ApiConsole'
import ApiMlpPhone from './ApiMlpPhone'
import ApiMlpTracking from './ApiMlpTracking'
import ApiStorage from './ApiStorage'
import ApiEvents from './ApiEvents'

export default {
  name: 'ApiModules',
  components: {
    ApiConsole,
    ApiMlpPhone,
    ApiMlpTracking,
    ApiStorage,
    ApiEvents
  },
  props: {
  },
  data () {
    return {
      isShowing: false,
      modules: [
        { id: 'api-console', name: 'Consola', icon: 'web_asset' },
        { id: 'api-storage', name: 'Almacenamiento', icon: 'sd_storage' },
        // { id: 'api-mlp-phone', name: 'Telefonos', icon: 'phone_android' },
        { id: 'api-tracking', name: 'Tracking de personas', icon: 'videocam' },
        { id: 'api-events', name: 'Eventos', icon: 'event' }
      ]
    }
  },
  computed: {
    showModules () {
      if (!this.editorConfig.isMobile) return true
      else if (this.editorConfig.isMobile && this.isShowing) return true
      else return false
    },
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    click_on_module: function (id) {
      this.isShowing = !this.isShowing
      if (this.editorConfig.selectedModule === id) {
        this.$store.commit('setEditorConfigProperty', {'selectedModule': 'none'})
      } else {
        this.$store.commit('setEditorConfigProperty', {'selectedModule': id})
      }
    }
  },
  mounted () {
    this.$store.commit('setEditorConfigProperty', {'selectedModule': 'api-console'})
  }
}
</script>

<style lang = "less">
@import (reference) "../../assets/styles/main.less";

@media (max-width: @breakPoint) {
  .api-modules #toolbar {
    align-items: left !important;
    justify-content: left !important;
    margin-top: 0 !important;
  }
}

.api-modules {
  display: flex;
  flex-direction: column;
  // background: @accentColor;
  // cursor: pointer;

  &:hover {
    // background: lighten(@accentColor, 10%);
  }

  &:active {
    // background: darken(@accentColor, 10%);
  }

  #selector {
    align-self: flex-end;
  }

  #toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 25px;
    height: 46px;
    margin-top: 15px;
    justify-content: center;

    #title {
      flex: 2;
    }

    button {
      color: @primaryTextColor;
      border-radius: 100px;
      width: 35px;
      height: 35px;

      &:hover {
        background: fade(@accentColor, 50%);
        // color: @secondaryTextColor;
      }

      &.selected {
        background: @accentColor;
        color: @primaryTextColor;
      }
    }
  }

  #content {
    display: flex;
    // align-items: center;
    flex-direction: column;
    background: @surfaceColor;
    // border: 3px solid @accentColor;
    .main-shadow-mixin;
    flex: 2;
    overflow: auto;
    width: 318px;
    overflow: hidden;
    min-height: 300px;
    position: relative;
    border-radius: 3px;
  }

  .api-module {
    display: flex;
    // align-items: center;
    flex-direction: column;
    width: 100%;
    top: 0;
    bottom: 0;
    position: absolute;
    // background: blue;

    .description {
      margin: 12px;
      color: @secondaryTextColor;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ApiModules/ApiModules.vue